const urls = {
	upload: {
		// uploadFile: "/file_upload",
		uploadFile: "https://files.medflying.com/file_system/files",
		uploadAccept: "https://files.medflying.com/file_system/upload_accept",
		uploadComplete: "https://files.medflying.com/file_system/upload_complete",
		uploadFileTransfer: "https://files.medflying.com/file_system/files_transfer",
		// uploadBase64: "/api/uploadbase64",
		"uploadBase64": "https://files.medflying.com/file_system/filesbase64",
		check_files: "/project/check_files"//检查文件是否重复
	},
	user: {
		login: "/auth/login",
	},
	index:{
		upload_file: "/gen_pic/files",
		send_prompt: "/gen_pic/send_prompt",
		get_history:"/gen_pic/get_history"
	}
}
export default urls;